import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import { useState } from 'react'
import { CSPProvider } from './CSPProvider'

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: true,
  },
  styles: {
    global: {
      'html, body': {
        fontSize: '17px', // base 16px + 1px; rem-based tokens scale up
      },
    },
  },
})

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1 minute
        retry: 1,
      },
    },
  }))

  // Note: Auth initialization is now handled in App.tsx to prevent race conditions
  // and ensure proper route generation timing

  return (
    <CSPProvider>
      <ChakraProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          {children}
        </QueryClientProvider>
      </ChakraProvider>
    </CSPProvider>
  )
}

